// Single source of truth for FIG Verify tier metadata.
// Used by Settings (subscription cards), the paywall modal, scan counter,
// and the consume_scan / payments-webhook edge functions (mirror in TS).

export type TierId = "one_off" | "collector" | "seller" | "pro_seller";

export interface Tier {
  id: TierId;
  priceId: string;          // Stripe price lookup_key
  name: string;
  priceLabel: string;
  cadence: string;          // "/month" or "one-time"
  scans: number;            // monthly allotment (or pack size)
  perScan: string;          // marketing copy
  bullets: string[];        // feature highlights
  popular?: boolean;
  recurring: boolean;
}

export const TIERS: Tier[] = [
  {
    id: "one_off",
    priceId: "oneoff_pack_10",
    name: "One-off Pack",
    priceLabel: "$1.99",
    cadence: "one-time",
    scans: 10,
    perScan: "$0.20 / scan",
    bullets: ["Core authentication report", "Era + construction notes"],
    recurring: false,
  },
  {
    id: "collector",
    priceId: "collector_monthly",
    name: "Collector",
    priceLabel: "$9.99",
    cadence: "/month",
    scans: 25,
    perScan: "$0.40 / scan",
    bullets: ["Core authentication report", "Era + construction notes"],
    recurring: true,
  },
  {
    id: "seller",
    priceId: "seller_monthly",
    name: "Seller",
    priceLabel: "$19.99",
    cadence: "/month",
    scans: 100,
    perScan: "$0.20 / scan",
    bullets: ["Full report", "Pricing guidance", "Platform recommendations", "Downloadable PDFs"],
    popular: true,
    recurring: true,
  },
  {
    id: "pro_seller",
    priceId: "pro_seller_monthly",
    name: "Pro Seller",
    priceLabel: "$49.99",
    cadence: "/month",
    scans: 300,
    perScan: "$0.17 / scan",
    bullets: ["Everything in Seller", "Bulk upload", "White-label PDFs", "Priority human review"],
    recurring: true,
  },
];

export const TIER_BY_PRICE: Record<string, Tier> = Object.fromEntries(
  TIERS.map((t) => [t.priceId, t]),
);

export const TIER_BY_ID: Record<TierId, Tier> = Object.fromEntries(
  TIERS.map((t) => [t.id, t]),
) as Record<TierId, Tier>;
